<app-core-offcanvas
  [headerTitle]="('instituation.instituation' | translate) + header"
  (closed)="onOffCanvasClosed()"
  width="100%"
  #instituationCanvas
  (chooseOn)="mode === 'edit' ? update() : save()"
  [saveText]="(mode === 'edit' ? 'common.update' : 'common.save') | translate"
  [showSaveButton]="
    (mode === 'edit' &&
      ('instituation-filter-list' | hasPermission : 'update')) ||
    (mode != 'edit' && ('instituation-filter-list' | hasPermission : 'create'))
  "
  [saveButtonDisable]="false"
>
  <div class="instituation-container">
    <div class="sidebar">
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'instituation'"
        (click)="setTab('instituation')"
      >
        <i class="la la-home sidebar-icon"></i>
        <span class="sidebar-text">Kurum Bilgileri</span>
      </button>
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'case'"
        (click)="setTab('case')"
      >
        <i class="la la-car sidebar-icon"></i>
        <span class="sidebar-text">Vaka Bilgileri</span>
      </button>
    </div>

    <div class="content">
      <div [hidden]="selectedTab !== 'instituation'">
        <form [formGroup]="form" class="pt-3">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12">
              <app-cards
                [title]="'instituation.instituation-information' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div bodyContent>
                  <ng-container>
                    <div class="row mb-2">
                      <div class="col-xl-6 col-md-12">
                        <label
                          for="instituationShortCode"
                          class="form-label font-w500"
                          >{{ "instituation.short-code" | translate }}</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="instituationShortCode"
                          formControlName="instituationShortCode"
                          [placeholder]="
                            'instituation.placeholder.title' | translate
                          "
                        />
                        <div
                          *ngIf="
                            form
                              .get('instituationShortCode')
                              ?.hasError('required') &&
                            form.get('instituationShortCode')?.touched
                          "
                          class="text-danger"
                        >
                          <small
                            *ngIf="form.get('instituationShortCode')?.errors?.['required']"
                            >{{ "validation.required" | translate }}</small
                          >
                        </div>
                      </div>
                      <div class="col-xl-6 col-md-12">
                        <label for="erpCode" class="form-label font-w500">
                          {{ "instituation.erp-code" | translate }}</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="erpCode"
                          formControlName="erpCode"
                          [placeholder]="
                            'instituation.placeholder.erp-code' | translate
                          "
                        />
                        <div
                          *ngIf="
                            form.get('erpCode')?.hasError('required') &&
                            form.get('erpCode')?.touched
                          "
                          class="text-danger"
                        >
                          <small
                            *ngIf="form.get('erpCode')?.errors?.['required']"
                            >{{ "validation.required" | translate }}</small
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <label for="title" class="form-label font-w500"
                        >{{ "instituation.title-label" | translate
                        }}<span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          id="title"
                          formControlName="title"
                          [placeholder]="
                            'instituation.placeholder.title' | translate
                          "
                        />
                      </div>

                      <div
                        *ngIf="
                          form.get('title')?.hasError('required') &&
                          form.get('title')?.touched
                        "
                        class="text-danger"
                      >
                        <small
                          *ngIf="form.get('title')?.errors?.['required']"
                          >{{ "validation.required" | translate }}</small
                        >
                      </div>
                    </div>

                    <div class="row mb-2">
                      <label for="signboard" class="form-label font-w500">
                        {{ "instituation.signboard" | translate
                        }}<span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          id="signboard"
                          formControlName="signboard"
                          [placeholder]="
                            'instituation.placeholder.signboard' | translate
                          "
                        />
                      </div>
                      <div
                        *ngIf="
                          form.get('signboard')?.hasError('required') &&
                          form.get('signboard')?.touched
                        "
                        class="text-danger"
                      >
                        <small
                          *ngIf="form.get('signboard')?.errors?.['required']"
                          >{{ "validation.required" | translate }}</small
                        >
                      </div>
                    </div>

                    <div class="row mb-2">
                      <label for="mainInstituationId" class="form-label">{{
                        "instituation.main-instituation" | translate
                      }}</label>
                      <p-dropdown
                        [options]="mainInstituations"
                        formControlName="mainInstituationId"
                        [showClear]="true"
                        [placeholder]="'general.select-please' | translate"
                      >
                      </p-dropdown>
                      <div
                        *ngIf="
                          form
                            .get('mainInstituationId')
                            ?.hasError('required') &&
                          form.get('mainInstituationId')?.touched
                        "
                        class="text-danger"
                      >
                        <small
                          *ngIf="form.get('mainInstituationId')?.errors?.['required']"
                          >{{ "validation.required" | translate }}</small
                        >
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-xl-6 col-md-12">
                        <label for="instituationType" class="form-label"
                          >{{ "instituation.instituation-type" | translate
                          }}<span class="text-danger">*</span></label
                        >
                        <p-dropdown
                          [options]="instituationsTypes"
                          formControlName="instituationType"
                          [showClear]="true"
                          [placeholder]="'general.select-please' | translate"
                        >
                        </p-dropdown>

                        <div
                          *ngIf="
                            form
                              .get('instituationType')
                              ?.hasError('required') &&
                            form.get('instituationType')?.touched
                          "
                          class="text-danger"
                        >
                          <small
                            *ngIf="form.get('instituationType')?.errors?.['required']"
                            >{{ "validation.required" | translate }}</small
                          >
                        </div>
                      </div>

                      <div class="col-xl-6 col-md-12">
                        <div
                          class="form-check form-switch d-flex justify-content-between col-xl-12 ps-0 mt-3"
                        >
                          <label class="form-check-label" for=""
                            >{{ "instituation.active-passive" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            formControlName="isActive"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            aria-checked="true"
                          />
                        </div>

                        <div
                          class="form-check form-switch d-flex justify-content-between col-xl-12 ps-0 mt-3"
                        >
                          <label class="form-check-label" for="">
                            {{ "instituation.mother-child-status" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            formControlName="isMotherChildInstituation"
                            type="checkbox"
                            role="switch"
                            id="isMotherChildInstituation"
                            aria-checked="false"
                          />
                        </div>

                        <div
                          *ngIf="
                            form
                              .get('isMotherChildInstituation')
                              ?.hasError('required') &&
                            form.get('isMotherChildInstituation')?.touched
                          "
                          class="text-danger"
                        >
                          <small
                            *ngIf="form.get('isMotherChildInstituation')?.errors?.['required']"
                            >{{ "validation.required" | translate }}</small
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <label for="note" class="col-xl-12 col-form-label">
                        {{ "instituation.note" | translate }}</label
                      >
                      <div class="col-xl-12">
                        <textarea
                          formControlName="note"
                          class="form-control"
                          id="note"
                          rows="4"
                          [placeholder]="
                            'instituation.placeholder.note' | translate
                          "
                        ></textarea>
                      </div>
                      <div
                        *ngIf="
                          form.get('note')?.hasError('required') &&
                          form.get('note')?.touched
                        "
                        class="text-danger"
                      >
                        <small *ngIf="form.get('note')?.errors?.['required']">{{
                          "validation.required" | translate
                        }}</small>
                      </div>
                    </div>
                    <div class="row mb-2">
                    
                      <div class="col-xl-6 col-md-6 col-12">
                        <div class="form-check form-switch d-flex justify-content-between ps-0 mt-3">
                          <label class="form-check-label">
                            {{ "instituation.provisionable" | translate }}
                          </label>
                          <input class="form-check-input" formControlName="provisionable" type="checkbox" role="switch"
                            id="provisionable" />
                        </div>
                      </div>
                    
                      <div class="col-xl-6 col-md-6 col-12">
                        <div class="form-check form-switch d-flex justify-content-between ps-0 mt-3">
                          <label class="form-check-label">
                            {{ "instituation.invoiceable" | translate }}
                          </label>
                          <input class="form-check-input" formControlName="invoiceable" type="checkbox" role="switch" id="invoiceable" />
                        </div>
                      </div>
                       <div class="col-xl-12 col-md-12 col-12">
                        <div class="form-check form-switch d-flex justify-content-between ps-0 mt-3">
                          <label class="form-check-label">
                            {{ "instituation.isFieldSales" | translate }}
                          </label>
                          <input class="form-check-input" formControlName="isFieldSales" type="checkbox" role="switch" id="isFieldSales " />
                        </div>
                      </div>
                    
                    </div>
                   
                  </ng-container></div
              ></app-cards>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <app-cards
                [title]="'instituation.tax-information' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div bodyContent>
                  <ng-container>
                    <div class="row mb-2">
                      <div class="col-xl-6 col-md-12 border-class">
                        <div class="col-12 mb-2">
                          <label for="taxOffice" class="form-label font-w500"
                            >{{ "instituation.tax-office" | translate
                            }}  <span class="text-danger" *ngIf="form.get('invoiceable')?.value">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="taxOffice"
                            formControlName="taxOffice"
                            [placeholder]="
                              'instituation.placeholder.tax-office' | translate
                            "
                          />

                          <div
                            *ngIf="
                              form.get('taxOffice')?.hasError('required') &&
                              form.get('taxOffice')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('taxOffice')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>

                        <div class="col-12 mb-2">
                          <label for="taxNumber" class="form-label font-w500"
                            >{{ "instituation.tax-number" | translate
                            }}  <span class="text-danger" *ngIf="form.get('invoiceable')?.value">*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="taxNumber"
                            formControlName="taxNumber"
                            [placeholder]="
                              'instituation.placeholder.tax-number' | translate
                            "
                          />
                          <div
                            *ngIf="
                              form.get('taxNumber')?.hasError('required') &&
                              form.get('taxNumber')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('taxNumber')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>

                        <div class="col-12 mb-2">
                          <label for="termDay" class="form-label font-w500">
                            {{
                              "instituation.term-day-label" | translate
                            }}</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="termDay"
                            formControlName="termDay"
                            [placeholder]="
                              'instituation.placeholder.term-day' | translate
                            "
                            pattern="[0-9]*"
                            (input)="onInput($event)"
                          />

                          <div
                            *ngIf="
                              form.get('termDay')?.hasError('required') &&
                              form.get('termDay')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('termDay')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-6 col-md-12">
                        <div class="col-12 mb-2">
                          <label
                            for="labmedUsername"
                            class="form-label font-w500"
                          >
                            {{
                              "instituation.labmed-username" | translate
                            }}</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="labmedUsername"
                            formControlName="labmedUsername"
                            [placeholder]="
                              'instituation.placeholder.labmed-username'
                                | translate
                            "
                          />
                          <div
                            *ngIf="
                              form
                                .get('labmedUsername')
                                ?.hasError('required') &&
                              form.get('labmedUsername')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('labmedUsername')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>

                        <div class="col-12 mb-2">
                          <label
                            for="labmedInstituationCode"
                            class="form-label font-w500"
                          >
                            {{
                              "instituation.labmed-instituation-code"
                                | translate
                            }}</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="labmedInstituationCode"
                            formControlName="labmedInstituationCode"
                            [placeholder]="
                              'instituation.placeholder.labmed-instituation-code'
                                | translate
                            "
                          />
                          <div
                            *ngIf="
                              form
                                .get('labmedInstituationCode')
                                ?.hasError('required') &&
                              form.get('labmedInstituationCode')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('termDlabmedInstituationCodeay')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>

                        <div class="col-12 mb-2">
                          <label
                            for="labmedUserPassword"
                            class="form-label font-w500"
                          >
                            {{
                              "instituation.labmed-password" | translate
                            }}</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="labmedUserPassword"
                            formControlName="labmedUserPassword"
                            [placeholder]="
                              'instituation.placeholder.labmed-password'
                                | translate
                            "
                          />

                          <div
                            *ngIf="
                              form
                                .get('labmedUserPassword')
                                ?.hasError('required') &&
                              form.get('labmedUserPassword')?.touched
                            "
                            class="text-danger"
                          >
                            <small
                              *ngIf="form.get('labmedUserPassword')?.errors?.['required']"
                              >{{ "validation.required" | translate }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div></app-cards
              >
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <app-cards
                [title]="'instituation.contact-information' | translate"
                footerDivider="border-0 pb-0 "
                class="custom-cardbox-area"
              >
                <div bodyContent>
                  <ng-container>
                    <div class="col-xl-12 mb-2">
                      <app-phone-list
                        #phoneList
                        [phones]="phones"
                        [types]="phoneTypes"
                        (phoneItemsChange)="updatePhoneItems($event)"
                        [prefixValue]="true"
                        [showDescriptionInput]="true"
                        [showSearchIcon]="false"
                        [title]="'instituation.phone-numbers' | translate"
                        [form]="form"
                        [isSubmit]="isSubmit"
                      ></app-phone-list>
                    </div>
                    <core-address-input
                      [form]="form"
                      (openModal)="openAddressModal()"
                      [showMapButton]="true"
                    ></core-address-input>
                  </ng-container></div
              ></app-cards>
            </div>
          </div>
        </form>
      </div>

      <!-- Vaka Hareketleri -->
      <div [hidden]="selectedTab !== 'case'">
        <div class="mb-2 mt-4 d-flex-between">
          <div class="d-grid">
            <h3 class="mb-0">
              {{ "instituation.case.table-name" | translate }}
            </h3>
          </div>
          <div class="d-flex align-items-center">
            <a
              class="btn btn-warning ms-2"
              (click)="showCaseCollapse = !showCaseCollapse"
            >
              {{ "general.filter" | translate }}
            </a>
          </div>
        </div>

        <app-filter-container
          [placeholder]="'general.filter' | translate"
          (closeOn)="showCaseCollapse = !showCaseCollapse"
          [show]="showCaseCollapse"
        >
          <div class="row">
            <div class="col-xl-3 col-sm-6 mb-3">
              <label for="">
                {{ "instituation.case.filter.start-date" | translate }}
              </label>
              <p-calendar
                [(ngModel)]="caseFilter.startDate"
                [placeholder]="
                  'instituation.case.filter.start-date' | translate
                "
                [showTime]="false"
                [showButtonBar]="true"
                appendTo="body"
                #startCalendar
              />
            </div>

            <div class="col-xl-3 col-sm-6 mb-3">
              <label for="">
                {{ "instituation.case.filter.end-date" | translate }}
              </label>
              <p-calendar
                [(ngModel)]="caseFilter.endDate"
                [placeholder]="'instituation.case.filter.end-date' | translate"
                [showTime]="false"
                [showButtonBar]="true"
                appendTo="body"
                #startCalendar
              />
            </div>
            <div class="col-xl-3 col-sm-6 col-12">
              <label for="">
                {{ "instituation.case.filter.case-type" | translate }}
              </label>
              <p-dropdown
                [options]="caseTypes"
                type="single"
                response="value"
                version="ngModel"
                [(ngModel)]="caseFilter.caseType"
                [filter]="true"
                [placeholder]="'instituation.case.filter.case-type' | translate"
              ></p-dropdown>
            </div>

            <div class="col-xl-3 col-sm-6 col-12">
              <label for="">{{
                "instituation.case.filter.case-status" | translate
              }}</label>
              <p-dropdown
                [options]="statuses"
                type="single"
                response="value"
                version="ngModel"
                [(ngModel)]="caseFilter.caseStatus"
                [filter]="true"
                [placeholder]="
                  'instituation.case.filter.case-status' | translate
                "
              ></p-dropdown>
            </div>
            <div class="col-xl-3 col-sm-6 col-12">
              <label for="">
                {{ "Çağrı Kurumu" }}
              </label>
              <input
                class="form-check-input"
                style="margin-left: 5%"
                [(ngModel)]="caseFilter.callInstitution"
                type="checkbox"
                role="switch"
                aria-checked="true"
              />
            </div>
            <div class="col-xl-3 col-sm-6 col-12">
              <label for="">
                {{ "Alınan Kurumu" }}
              </label>
              <input
                class="form-check-input"
                style="margin-left: 5%"
                [(ngModel)]="caseFilter.pickupInstitution"
                type="checkbox"
                role="switch"
                aria-checked="true"
              />
            </div>
            <div class="col-xl-3 col-sm-6 col-12">
              <label for="">
                {{ "Bırakılan Kurumu" }}
              </label>
              <input
                class="form-check-input"
                style="margin-left: 5%"
                [(ngModel)]="caseFilter.dropoffInstitution"
                type="checkbox"
                role="switch"
                aria-checked="true"
              />
            </div>

            <div class="col-12 d-flex justify-content-end mt-3">
              <button
                class="btn btn-danger light"
                (click)="clearCaseFilter()"
                type="button"
              >
                {{ "general.clear-filter" | translate }}
              </button>
              <button
                (click)="getCaseList({})"
                class="btn btn-info ms-2"
                type="button"
              >
                {{ "general.filtering" | translate }}
                <i class="fa fa-search ms-2"></i>
              </button>
            </div>
          </div>
        </app-filter-container>
        <div class="table-responsive active-projects style-1">
          <div id="user-tbl_wrapper" class="dataTables_wrapper no-footer">
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-success" *ngIf="caseList?.length" (click)="exportToExcel()">
                Excel'e Aktar
              </button>
            </div>
            <p-table [rowHover]="true" responsiveLayout="stack" [rows]="rows" [first]="first" [totalRecords]="totalCaseRecords"
              [lazy]="true" (onLazyLoad)="getCaseList($event)" paginatorDropdownAppendTo="body" [value]="caseList"
              [paginator]="true" [scrollable]="true" scrollHeight="50vh" [rowsPerPageOptions]="[10, 20, 30]">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="id" style="width: 10%;" scope="col">
                    <span class="p-column-title">{{'common.id' | translate}} <p-sortIcon field="id" /></span>
                  </th>
                  <th pSortableColumn="protocolNo" style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.protocol-no" | translate }}
                      <p-sortIcon field="protocolNo" /></span>
                  </th>
                  <th pSortableColumn="caseDate" style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.case-date" | translate }}
                      <p-sortIcon field="caseDate" /></span>
                  </th>
                  <th style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.case-type" | translate }}
                    </span>
                  </th>
        
                  <th style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.case-status" | translate }}
                    </span>
                  </th>
        
                  <th style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.name-surname" | translate }}
                    </span>
                  </th>
        
                  <th style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.taken-instituation" | translate }}
                    </span>
                  </th>
        
                  <th style="width: 10%;" scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.left-instituation" | translate }}
                    </span>
                  </th>
        
                  <th scope="col">
                    <span class="p-column-title">
                      {{ "instituation.case.call-instituation" | translate }}
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-list>
                <tr>
                  <td>{{ list?.id }}</td>
                  <td>
                    <a [routerLink]="['/case/' + list.id]" target="_blank" rel="noopener noreferrer">
                      {{ list?.caseNo }}
                    </a>
                  </td>
                  <td>{{ list?.caseDate | dateFormat:true }}</td>
                  <td>{{ list?.caseType?.valueObject?.name?.value }}</td>
                  <td>
                    <span class="badge light border-0 badge-{{
                              (
                                   list?.caseStatus === 'started' ||
                                    list?.caseStatus === 'finished'
                              )
                                ? 'success'
                                : 'danger'
                            }}">
                      {{ list?.caseStatus | caseStatusPipe }}
                    </span>
                  </td>
                  <td>
                    {{
                    (list?.patientInformations?.firstName ?? "") +
                    " " +
                    (list?.patientInformations?.lastName ?? "")
                    }}
                  </td>
                  <td>
                    {{ list?.addressInformations?.pickupInstitution?.signboard }}
                  </td>
                  <td>
                    {{ list?.addressInformations?.dropoffInstitution?.signboard }}
                  </td>
                  <td>{{ list?.caseInformations?.institution?.signboard }}</td>
                </tr>
              </ng-template>
        
              <ng-template pTemplate="paginatorleft">
                {{ totalCaseRecords }}
                {{ "common.table.totalFound" | translate }}
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="99">{{ "common.noData" | translate }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-core-offcanvas>

<core-address-autocomplete
  #addressComponent
  [parentForm]="form"
  (setAddress)="handleSetAddress($event)"
  [showCountryPicker]="true"
></core-address-autocomplete>
